import { createSelector } from "@reduxjs/toolkit";

const selectActor = (state) => state.actor;

// Selector to check if both country and immigrantStatus are selected
export const hasCountryActorSelector = createSelector(selectActor, (actor) => {
  // console.log(actor.country);
  return actor.country;
});
